import { Button, Callout, Classes, MenuItem } from "@blueprintjs/core"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { withFormController } from "components/Molecules/FormController"
import { REFERENCE_GRADES } from "graphql/selector.queries.gql"
import { get } from "lodash-es"
import React from "react"

function HarvestGrades({ onRemove, source, onAdd, disabled, path }) {
  const harvestGrades = get(source, path, [])

  return (
    <div className="div">
      <h6 className="mt-5 vt-section-header">
        Harvest Grades <span className={Classes.INTENT_DANGER}>*</span>
      </h6>
      <hr className="mt-0" />
      {harvestGrades.map((d, index) => (
        <Callout key={index} className="px-4" style={{ background: "#F5F7FB" }}>
          <div key={index} className="grid grid-cols-12 gap-4 mt-2">
            <div className="ml-2 col-span-3">
              <DynamicSelector
                big={true}
                label="Grade Name"
                path={`${path}.${index}.name`}
                query={REFERENCE_GRADES}
                itemRenderer={(item, { handleClick, modifiers }) => {
                  const isSelected = harvestGrades.find(hg => {
                    const name = get(hg, "name.id", hg.name)
                    return name === item.id
                  })
                  return (
                    <MenuItem
                      disabled={isSelected}
                      active={modifiers.active}
                      key={item.id}
                      onClick={handleClick}
                      text={item.name}
                    />
                  )
                }}
                renderText={item => {
                  const name = get(item, "name", item)
                  return name ? name : "Select Grade..."
                }}
              />
            </div>
            <div className="col-span-6">
              <StringInput
                big={true}
                label="Grade Specifications"
                path={`${path}.${index}.specifications`}
              ></StringInput>
            </div>
            <div className="col-span-1 self-center">
              <Button
                disabled={disabled}
                tabIndex={-1}
                minimal={true}
                icon="minus"
                intent="danger"
                onClick={e => onRemove(path, index)}
              ></Button>
            </div>
          </div>
        </Callout>
      ))}
      <Callout className="px-4" style={{ background: "#F5F7FB" }}>
        <Button
          disabled={disabled || harvestGrades.length >= 3}
          minimal={true}
          small={true}
          intent="primary"
          icon="plus"
          onClick={() => onAdd(path, { name: null, specifications: "" })}
        >
          Harvest Grade
        </Button>
      </Callout>
    </div>
  )
  // }
}

HarvestGrades.defaultProps = {
  data: [],
}
export default withFormController(HarvestGrades)
